export default __webpack_public_path__ + "static/media/patient_toothChart.a2783c8c.png";